import { Component } from "@angular/core";
import { GlobalUtilsService } from "../global-utils.service";

@Component({
  selector: "app-lista-servicos",
  template: `
    <div class="tags-container {{ globalUtilsService.activeScreen }}">
      <span class="tag">Instrumentos de corda</span>
      <span class="tag">Teclados</span>
      <span class="tag">Cubos profissionais</span>
      <span class="tag">Percussão e Baterias</span>
      <span class="tag">Mesas de áudio</span>
      <span class="tag">Microfones</span>
      <span class="tag">Acessórios e muito mais!</span>
    </div>
  `,
  styles: [
    `
      .tags-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.18rem 0.1rem;
        padding: 0.4rem;
        font-family: "Metronic Pro", sans-serif;
      }

      .tag {
        background-color: #f0f0f0;
        font-family: "Metronic Pro", sans-serif;
        padding: 0.03rem 0.3rem;
        padding-top: 0.07rem;
        border-radius: 2rem;
        font-size: 0.35rem;
        white-space: nowrap;
        text-align: center;
      }

      .tags-container.tablet {
        justify-content: left;
        gap: 0.2rem 0.1rem;
        padding: 0;
      }

      .tags-container.tablet .tag {
        font-size: 0.75rem;
        padding: 0.1rem 0.6rem;
      }

      .tags-container.mobile {
        justify-content: center;
        gap: 0.35rem 0.1rem;
        padding: 0;
      }

      .tags-container.mobile .tag {
        font-size: 0.42rem;
        padding: 0.1rem 0.4rem;
      }

      .tags-container.mobile .tag:first-child,
      .tags-container.mobile .tag:nth-child(4) {
        margin: 0 2rem;
      }
    `,
  ],
})
export class ListaServicosComponent {
  constructor(public globalUtilsService: GlobalUtilsService) {}
}
